export enum LinkEntityType {
    TaggedItem = 'TaggedItem',
    Project = 'Project',
    ActivityPack = 'ActivityPack',
}
